import { Box, ButtonBase, Stack, Typography } from "@mui/material";

interface IconCardModuleProps {
  title: string;
  body: string;
  icon: any;
  onClick: () => any;
}

export default function IconCardModule(props: IconCardModuleProps) {
  return (
    <ButtonBase
      onClick={props.onClick}
      sx={{
        textAlign: "left",
        maxWidth: 350,
        p: 2,
        mx: -1,
        borderRadius: 1,
        my: 0.5,
      }}
    >
      <Box sx={{ mx: -1 }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "flex-start" }}>
          <Box>
            <props.icon color="primary" fontSize={"small"} />
          </Box>

          <Box>
            <Typography fontWeight={600} fontSize={"small"}>
              {props.title}
            </Typography>
            <Typography align="justify" color="text.secondary">
              {props.body}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </ButtonBase>
  );
}
